import React,{ Component } from 'react';

class Footer extends React.Component{
    render(){
    return(
        <div class="container" style={{backgroundColor:'black'}}>
        <h1 class="font_meie_script" style={{color:'white'}}>Contact Us</h1>
                <div class="text-center center-block">
                    <h3 class="txt-railway font_meie_script" style={{color:'white'}}>Getting In Touch is Easy!</h3>
                    <br />
                        <a href="https://www.facebook.com/Maths-Club-Sastra-1467163340190690/"><i id="social-fb" class="fa fa-facebook-square fa-3x social"></i></a>
                        <a href="https://instagram.com/mcs_sastra?igshid=41ed1sbj93wv"><i id="social-tw" class="fa fa-instagram fa-3x social"></i></a>
                        <a href=""><i id="social-gp" class="fa fa-google-plus-square fa-3x social"></i></a>
                        <a href="mailto:mathsclub.mcs@gmail.com"><i id="social-em" class="fa fa-envelope-square fa-3x social"></i></a>
        </div>
        </div>
    );
    }
}

export default Footer;